export default "__VITE_ASSET__Bp5IKj0s__"